import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { adminApi } from '../../../api';
import DICTIONARY from '../../../utils/dictionary';
import useDeleteForm from '../../../hooks/deleteFormHook';

// App Components

// Material UI Components
import { TextField } from '@material-ui/core';

// Colors
import {red} from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
}));

export default function DeleteEventDialog({ handleCloseDialog, eventId, adminEmail, teamId }) {
  const classes = useStyles();

  //#region Form Hook
  const initalFormState = {
		adminEmail: {
			label: DICTIONARY.EVENT.deleteEvent.form.field.adminEmail,
			value: '',
			isValid: true,
      required: true,
			validators: [],
		},
	};

	const onSubmit = async () => {
    const response = await adminApi.event.delete({eventId, teamId});

    if (response.hasOwnProperty("error")) {
      throw new Error(DICTIONARY.EVENT.deleteEvent.form.error.generalError);
    }
	}

	const onCloseModal = (isSubmittedSuccessfully) => {
    const shouldIgnoreHistoryPushBack = true;
    handleCloseDialog({isSubmittedSuccessfully, shouldIgnoreHistoryPushBack});
  }

	const {formState, formError, isLoading, isValidToDelete, handleInputChange, handleSubmit, handleCloseModal} = useDeleteForm({
		initalFormState, 
    validationValue: adminEmail,
		onSubmit, 
		onCloseModal,
	});
  //#endregion

  const dialogContent = (
    <React.Fragment>
      <TextField
        autoFocus
        margin="dense"
        id="adminEmail"
        name='adminEmail'
        label={formState.adminEmail.label}
        type="text"
        fullWidth
        value={formState.adminEmail.value}
        onChange={handleInputChange}
        autoComplete='adminEmail'
      />
    </React.Fragment>
  );

  return {
		dialogTitle: DICTIONARY.EVENT.deleteEvent.title,
		dialogContent,
    dialogContentText: (<span>{DICTIONARY.EVENT.deleteEvent.subtitle} <span style={{fontWeight: 'bold', color: 'black'}}>{adminEmail}</span></span>),
		sumbitButtonLabel: DICTIONARY.GENERAL.button.delete,
    submitButtonStyle: {backgroundColor: red[400]},
		handleSubmit,
		handleCloseModal,
		formError,
		isLoading,
    isValidToDelete,
	};
}